import type { LearningEdit } from '../services/agentLearning.ts';

// Preview the backend's complete block, including labels. Server values remain
// authoritative after publication; code points match Python's len().
export const learningPromptSize = (item: LearningEdit): number => {
  const field = (name: keyof LearningEdit) => String(item[name] || '').trim();
  const kind = field('kind');
  const lines = [`1. ${kind === 'example' ? 'Exemplo' : 'Orientação'} revisado(a):`];
  const condition = field('when_to_use');
  const instruction = field('instruction');
  const response = field('assistant_example');
  if (condition) lines.push(`   Condição: ${condition}`);
  if (instruction) lines.push(`   Orientação: ${instruction}`);
  if (kind === 'example') {
    if (field('user_example')) lines.push(`   Paciente: ${field('user_example')}`);
    if (response) lines.push(`   Resposta sugerida: ${response}`);
  } else if (response && response !== instruction) lines.push(`   Exemplo de resposta: ${response}`);
  return lines.length > 1 ? Array.from(`# APRENDIZADOS REVISADOS DE COMUNICAÇÃO DA CLÍNICA\n${lines.join('\n')}`).length : 0;
};
